import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { CreateAccountBaseComponent } from "@mypxplat/xplat/features";
import { UserService, WindowService, ProductService, environment, StorageService, StorageKeys, HelperService, BaseComponent } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "@mypxplat/xplat/web/core";
import { Hub } from "aws-amplify/utils";
import { fetchAuthSession, signIn, signInWithRedirect } from "aws-amplify/auth";
import { Amplify } from "aws-amplify";
import { ForgotpasswordComponent } from "../forgotpassword/forgotpassword.component";
@Component({
  selector: "myp-authenticate-fender-user",
  templateUrl: "authenticate-fender-user.component.html",
  standalone: false,
})
export class AuthenticateFenderUserComponent extends BaseComponent implements OnInit {
  @Output() fenderCognitoAttributesRetrieved: EventEmitter<any> = new EventEmitter();
  @Input() isThirdPartyProvider: boolean = false;
  @Input() presonusIdToken: string;
  @Input() newFenderUserCreated: string;
  public email: string;
  public password: string;
  public loading: boolean = false;
  public errorMessage: string = "";
  public passwordVisible: boolean = false;
  public loginMethod: string;
  public userAlreadyMigrated: boolean = false;
  constructor(
    public userService: UserService,
    public storageService: StorageService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public productService: ProductService,
    public helperService: HelperService,
    public appService: AppService,
    private router: Router,
    private _spin: NgxSpinnerService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (!this.newFenderUserCreated) {
      let redirectUrl = environment.mypresonusUrl + "login";
      if (this.appService.app == "presonus_connect") redirectUrl = environment.connectUrl + "home";
      this.loading = true;
      this.userService.checkFenderLoginMethod(this.email, this.presonusIdToken).subscribe((result: any) => {
        this.loading = false;
        this.loginMethod = result.loginMethod;
        if (result.cognitoUserData && result.user) {
          let attrs = result.cognitoUserData.UserAttributes;
          if (attrs.find((attr) => attr.Name === "custom:prs-id") && result.user.fender_cognito_user_id) {
            this.userAlreadyMigrated = true;
          }
        }
      });
      Amplify.configure({
        Auth: {
          Cognito: {
            userPoolClientId: environment.fenderCognito.clientId,
            userPoolId: environment.fenderCognito.userPoolId,
            loginWith: {
              oauth: {
                providers: ["Google", "Facebook", "Apple"],
                domain: environment.fenderCognito.domain,
                scopes: ["email", "profile", "openid", "aws.cognito.signin.user.admin"],
                redirectSignIn: [redirectUrl],
                redirectSignOut: [redirectUrl],
                responseType: "code",
              },
            },
          },
        },
      });
      Hub.listen("auth", (result) => {
        switch (result.payload.event) {
          case "signedIn":
            this.handleSignedInEvent();
            break;
          case "signInWithRedirect":
            this.handleSignedInEvent();
            break;
        }
      });
    }
  }

  async handleSignedInEvent() {
    try {
      let session = await fetchAuthSession({ forceRefresh: false });
      if (session.tokens) {
        this.fenderCognitoAttributesRetrieved.emit(session.tokens);
        this.activeModal.close();
      }
    } catch (error) {
      console.error("Error in handleSignedInEvent:", error);
    }
  }

  async submit() {
    if (this.email && this.password) {
      this.loading = true;
      try {
        await signIn({
          username: this.email.toLowerCase(),
          password: this.password,
          options: {
            authFlowType: "USER_SRP_AUTH",
          },
        });
      } catch (error) {
        console.error("Failed to re-authenticate:", error);
        this.errorMessage = this.helperService.retrieveErrorMessage(error);
        this.loading = false;
      }
    } else {
      this.errorMessage = "Please enter your email and password, or login with your 3rd party provider.";
    }
  }

  async signInWith(provider) {
    this.storageService.setItem(StorageKeys.SOCIAL_SIGN_IN_FLOW_TYPE, provider.toLowerCase());
    try {
      this.loading = true;
      await signInWithRedirect({
        provider: provider,
      });
    } catch (error) {
      this.storageService.removeItem(StorageKeys.SOCIAL_SIGN_IN_FLOW_TYPE);
      this.errorMessage = this.helperService.retrieveErrorMessage(error);
      console.error(`Failed to sign in with ${provider}:`, error);
      this.loading = false;
    }
  }

  startForgotPassword() {
    const modalRef = this.appService.showModal(ForgotpasswordComponent, { size: "sm" });
    modalRef.componentInstance.resetPasswordWithEmail = this.email.toLowerCase();
    modalRef.componentInstance.switchToFenderPool = true;
  }
}
